import React, {Component} from 'react'
import {Button, ListGroup, ListGroupItem, Modal, DropdownButton, MenuItem} from 'react-bootstrap'
import cn from 'classnames';

class StudyWords extends Component {
    handleStudyAnswer = (indexClickedAnwer) => (e) => {
        this.props.handleStudyAnswer({indexClickedAnwer});
        const studyTask = this.props.studyTask;
        const isCorrect = studyTask.variantsTranslte[indexClickedAnwer].isCorrect;

        e.target.blur();
        e.target.parentElement.blur();

        setTimeout(() => this.props.getUserWords(this.props.userWords, studyTask, isCorrect), 300);
    };

    handleStudied = (studied) => {
        this.props.setWordStudied(this.props.userWords, this.props.studyTask, studied);

    };

    render() {
        const studyTask = this.props.studyTask;

        return (
            <div>
                <Modal show={this.props.modalStudyWordsState !== 'close'}>
                    <Modal.Body>
                        <div>
                            <div className="h1 text-center" style={{marginBottom: '5px'}}>{studyTask.value}</div>
                            <div className="text-center text-muted"
                                 style={{marginBottom: '20px'}}>{studyTask.forms ? studyTask.forms : <br/>}</div>
                            {studyTask.variantsTranslte ?
                                <ListGroup className="text-center">
                                    {studyTask.variantsTranslte.map((variant, index) => {
                                        const bsStyle = cn({
                                            success: (variant.isClicked && variant.isCorrect),
                                            danger: (variant.isClicked && !variant.isCorrect),
                                        });
                                        return (
                                            <ListGroupItem
                                                key={index}
                                                bsStyle={bsStyle ? bsStyle : null}
                                                onClick={studyTask.isAnswerClicked ? null : this.handleStudyAnswer(index)}
                                                value={index}
                                                header={variant.translate}
                                                href="#"
                                            />
                                        );
                                    })}
                                </ListGroup>
                                : null
                            }
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <DropdownButton
                            title={'действие'}
                            style={{marginRight: '5px'}}
                        >
                            <MenuItem onClick={studyTask.isAnswerClicked ? null : () => this.handleStudied(true)}>Я знаю
                                это слово</MenuItem>
                        </DropdownButton>

                        <Button onClick={() => this.props.turnSound({soundOn: !this.props.soundOn})}>
                            {this.props.soundOn ?
                                <span className="glyphicon glyphicon-volume-up" aria-hidden="true"/>
                                :
                                <span className="glyphicon glyphicon-volume-off" aria-hidden="true"/>
                            }
                        </Button>

                        <Button onClick={() => this.props.playAudio()}>
                            <span className="glyphicon glyphicon-play" aria-hidden="true"/>
                        </Button>
                        <Button onClick={this.props.toggleStudyWordsModal}>Закрыть</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default StudyWords;



// WEBPACK FOOTER //
// ./src/components/StudyWords.js